<a
    class="group flex items-center justify-between gap-20 bg-white px-24 py-8 text-accent"
    [hyundaiRouterLink]="link()"
    [queryParams]="{ utm_medium: 'dealer' }"
    [target]="target()"
    (click)="click.emit()"
>
    <div class="flex flex-col font-headline">
        <span class="text-20 font-medium leading-25">
            <ng-content select="[head]" />
        </span>
        <span class="text-160 font-medium leading-27"><ng-content select="[sub]" /></span>
    </div>
    <i class="animated-arrow-right text-24"></i>
</a>
